import { Mail, Github, Linkedin, FileText, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { profile } from "../../data/portfolioData";

const items = [
    {
        id: "email",
        label: "Email",
        meta: profile.links.emailRaw,
        href: profile.links.email,
        Icon: Mail,
        primary: true,
    },
    {
        id: "github",
        label: "GitHub",
        meta: "anima-regem",
        href: profile.links.github,
        Icon: Github,
    },
    {
        id: "linkedin",
        label: "LinkedIn",
        meta: "viswanathakarthav",
        href: profile.links.linkedin,
        Icon: Linkedin,
    },
    {
        id: "resume",
        label: "Resume",
        meta: "PDF · coming soon",
        href: profile.links.resume,
        Icon: FileText,
    },
];

export const ContactSection = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="08"
                    kicker="Contact"
                    title="Want to build something, collaborate, or talk infra?"
                    subtitle="Reach out — happy to chat about projects, weird ideas, hackathons, internships, or just say hi."
                />

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
                    {items.map((it) => (
                        <a
                            key={it.id}
                            href={it.href}
                            target={it.id === "email" ? "_self" : "_blank"}
                            rel="noreferrer"
                            data-testid={`contact-${it.id}-link`}
                            className={`group flex items-center justify-between gap-4 rounded-xl border p-5 transition-all duration-300 hover:-translate-y-1 md:p-6 ${
                                it.primary
                                    ? "border-ink-cyan/40 bg-[var(--ink-surface)] hover:border-ink-cyan/70"
                                    : "border-[var(--ink-border)] bg-[var(--ink-surface)] hover:border-ink-cyan/30"
                            }`}
                        >
                            <div className="flex items-center gap-4">
                                <span
                                    className={`inline-flex h-11 w-11 items-center justify-center rounded-md border ${
                                        it.primary
                                            ? "border-ink-cyan/40 bg-ink-cyan/10 text-ink-cyan"
                                            : "border-[var(--ink-border)] bg-[var(--ink-surface-muted)] text-[var(--ink-text-primary)]"
                                    }`}
                                >
                                    <it.Icon className="h-5 w-5" />
                                </span>
                                <div className="text-left">
                                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                                        {it.label}
                                    </div>
                                    <div className="mt-1 text-base text-[var(--ink-text-primary)] md:text-lg">
                                        {it.meta}
                                    </div>
                                </div>
                            </div>
                            <ArrowUpRight className="h-5 w-5 text-[var(--ink-text-secondary)] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink-cyan" />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
